import { render, staticRenderFns } from "./editPass.vue?vue&type=template&id=1dbc755c&scoped=true&"
import script from "./editPass.vue?vue&type=script&lang=js&"
export * from "./editPass.vue?vue&type=script&lang=js&"
import style0 from "./editPass.vue?vue&type=style&index=0&id=1dbc755c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbc755c",
  null
  
)

export default component.exports